import styled from 'styled-components'

export const OnboarderRouteWrapper = styled.div`
  width: 100%;
  background-color: #f5f5f5;
`
